import type { Type } from '.';

export function WpDebug(bool?: Type.WpDebug) {
	return bool ?? false;
}
